export default __webpack_public_path__ + "static/media/mail.bf36e373.svg";